<template>
<van-skeleton title avatar :row="6" :loading="loading">
  <div class="hisdiv0">
    <div class="div1" v-for="(item,idx) in list" :key="idx">
      <van-panel>
        <template #header></template>
        <template #footer>
          <div class="footer" v-if="item.list.length > 3">
            <span class="footer_title">共计 <span class="red">{{item.list.length}}</span> 件商品</span>
            <span class="footer_right">more...</span>
          </div>
          <div class="footer_btn">
            <div class="title_div van-ellipsis"><span class="footer_title">运费模板：{{item.frightName}}</span></div>
            <div class="info" @click="gocopyFun(idx)">复用</div>
          </div>
        </template>
        <div class="content">
          <div class="order_item" v-for="(t,i) in item.list" :key="i">
            <div class="order_info" v-if="i < 3">
              <div class="img">
                <van-image
                  :src="t.imageUrlsKeyUrl && t.imageUrlsKeyUrl.split(',')[0] &&  t.imageUrlsKeyUrl.split(',')[0]+'?x-oss-process=style/style_myorder_list_img'"
                  width="70"
                  height="70"
                  fit="cover" 
                /> 
              </div>
              <div class="info">
                <p class="infop1">
                  <strong class="van-multi-ellipsis--l2">{{t.itemName}}</strong>
                </p>
                <p class="attr flex-center">
                  <span>￥{{t.price}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </van-panel>
    </div>
  </div>
</van-skeleton>
</template>
<script>
import Util from "@/utils/common";

import http from "@/utils/axios";
export default {
  name: '',
  props: {
   
  },
  data() {
    return {
      loading: true,
      list: [],
      branchId: this.$route.query.branchId || ''
    }
  },
  methods: {
    init(){
      if(!this.branchId){return;}
      http({
        url: "/order/bees/quickOrder/orderTemplateHistory",
        method: "post",
        parmes: {
          "branchId": this.branchId
        }
      })
        .then(rps => {
          this.list = rps.data;
          this.$loading.hide()
          this.loading = false
        })
        .catch(err => {
          this.$loading.hide()
        })
    },
    gocopyFun(idx){
      Util.nativeMethod({tm:3040201,tp:{orderTemplateId: this.list[idx].id}})
      Util.finishPage();
    }
  },
  created() {
    
    this.init()
  },
  watch:{
    
  },
  destroyed(){
    
  },
  mounted(){},
  computed:{},
  components: {},
}
</script>
<style lang="less" scoped>
[class*=van-hairline]::after {
  border: none
}
.hisdiv0 {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 20px;
  .div1{
    margin-bottom: 20px;
  }
  .footer {
    font-size: 20px;
    color: #999;
    border-radius: 10px;
    clear: both;
    .red{
      color: #ED3939;
    }
    .footer_right{
      float: right;
    }
  }
  .footer_btn{
    display: flex;
    justify-content: space-between;
    .title_div{
      height: 60px;
      line-height: 45px;
      .footer_title{
        font-size: 24px;
        color: #999999;
      }
    }
    .info{
      width: 148px;
      height: 56px;
      background: var(--epButtonColor);
      border: 1PX solid var(--epButtonColor);
      color:var(--epTextColor);
      border-radius: 10px;
      font-size: 24px;
      text-align: center;
      line-height: 56px;
    }
  }
  .content{
    padding-top: 10px;
    .order_item {
      margin: 0 30px;
      .order_info {
        padding-bottom: 20px;
        padding-top: 20px;
        display: flex;
        border-bottom:1PX solid #EEEEEE;
        .info {
          flex: 1;
          .infop1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 26px;
            height: 74px;
            margin-bottom: 29px;
            span {
              color: #999;
            }
            strong {
              color: #333;
            }
          }
          .attr {
            color: #999999;
            font-size: 24px;
            height: 37px;
            line-height: 37px;
          }
        }
        .img {
          width: 140px;
          height: 140px;
          padding-right: 20px;
        }
      }
    }
    
  }
  .van-swipe-cell__right {
    .van-button {
      height: 100%;
    }
  }
   .van-cell-group{
     border-radius: 10px;
  }
  .van-hairline--top::after{
    border-top-width:0;
  }
}
</style>